<template>
  <main>
    <div
        class="d-flex align-items-center p-3 p-md-5 text-center bg-body-tertiary main-banner position-relative"
    >
      <div class="col-md-4 p-lg-5 mx-auto my-5 bg-banner-text mx-auto">
        <h1 class="display-1 fw-bold text-white"><span class="text-danger p-2">|</span>DART<span class="text-success p-2">|</span>CLUB<span class="text-danger p-2">|</span>WISŁA<span class="text-success p-2">|</span></h1>
        <!--        <h3 class="fw-normal text-muted mb-3">-->
        <!--          Build anything you want with Aperture-->
        <!--        </h3>-->
        <!--        <div class="d-flex gap-3 justify-content-center lead fw-normal">-->
        <!--          <a class="icon-link" href="#">-->
        <!--            Learn more-->
        <!--            <svg class="bi" aria-hidden="true">-->
        <!--              <use xlink:href="#chevron-right"></use>-->
        <!--            </svg>-->
        <!--          </a>-->
        <!--          <a class="icon-link" href="#">-->
        <!--            Buy-->
        <!--            <svg class="bi" aria-hidden="true">-->
        <!--              <use xlink:href="#chevron-right"></use>-->
        <!--            </svg>-->
        <!--          </a>-->
        <!--        </div>-->
      </div>
      <!--      <div class="product-device shadow-sm d-none d-md-block"></div>-->
      <!--      <div-->
      <!--          class="product-device product-device-2 shadow-sm d-none d-md-block"-->
      <!--      ></div>-->
      <div class="logo-overlap-container">
        <img src="../assets/logo_s.png" alt="Dart Club Wisła Logo" class="logo-overlap-img" />
      </div>
    </div>
    <div class="d-md-flex flex-md-equal w-100 my-md-3 ps-md-3">
      <router-link to="/rezerwacje" class="me-md-3 text-center overflow-hidden bg-reservation-box text-decoration-none">
        <div class="d-flex align-items-center justify-items-center overflow-hidden bg-black bg-opacity-75 h-100 w-100">
          <div class="my-5 p-5 text-white mx-auto">
            <h2 class="display-5">Rezerwacja online</h2>
            <p class="lead">Zarezerwuj stanowisko!</p>
          </div>
        </div>
      </router-link>
      <router-link to="/stanowiska" class="me-md-3 text-center overflow-hidden bg-plan-box text-decoration-none">
        <div class="d-flex align-items-center justify-items-center overflow-hidden bg-black bg-opacity-75 h-100 w-100">
          <div class="my-5 p-5 text-white mx-auto">
            <h2 class="display-5">Mapa stanowisk</h2>
            <p class="lead">Sprawdź rozlokowanie stanowisk do rzucania!</p>
          </div>
        </div>
      </router-link>
    </div>

    <div class="my-3">
      <div class="p-5 text-left bg-body-tertiary bg-bar">
        <div class="col-4 p-5 ">
          <h1 class="text-body-emphasis">Bar</h1>
          <p class="col-lg-12 mx-left lead">
            Zamów chłodny napój dla przyjemniejszej gry lub wrzuć na ruszt małą przekąskę w postaci zapiekanki lub innych przegryzek.
          </p>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
export default {
  name: 'MainPage',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Cinzel+Decorative:wght@400;700;900&family=Tourney:ital,wght@0,100..900;1,100..900&display=swap');

.main-banner {
  background-image: url('../assets/img/banner_shields.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50% 15%;
  min-height: 50vh;
}

.logo-overlap-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  z-index: 100;
}

.logo-overlap-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.6));
  transition: transform 0.3s ease;
}

.logo-overlap-img:hover {
  transform: scale(1.05);
}

.logo-overlap-container:hover .logo-overlap-img {
  transform: scale(1.08);
}

.bg-banner-text {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.bg-reservation-box {
  background-image: url('../assets/img/banner_reserve.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50% 25%;

  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}

.bg-plan-box {
  background-image: url('../assets/img/banner_local.jpg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50% 25%;

  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}

.bg-bar {
  background-image: url('../assets/bar_banner.jpg');
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: right;

  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}
</style>
